import { render, staticRenderFns } from "./ShareFeedback.vue?vue&type=template&id=5bfe7a9b&scoped=true"
import script from "./ShareFeedback.vue?vue&type=script&lang=ts"
export * from "./ShareFeedback.vue?vue&type=script&lang=ts"
import style0 from "./ShareFeedback.vue?vue&type=style&index=0&id=5bfe7a9b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe7a9b",
  null
  
)

export default component.exports